import { useEffect, useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
//---------------------------------------------------------------------
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import { useMyStore } from "src/components/main/mainStore";
import {
    onlyUnique, getDatefromWeekNum, weeknum, getTimeStamp, 
    myAxios, boolAndReducer, 
    arrayReducer, isDevMode, MyDate, MyFormData, buildWeekNumArray,
    appTitle
} from "src/components/common/functions";
//---------------------------------------------------------------------
export default function OffCalendar({ tabTitle }){
    const title = "OffCalendar";
    const user = useMyStore(state => state.user);
    const calculateEndTime = (startTime, duration) => {
        if(startTime === undefined || startTime === "" || duration === 0){
            return undefined;
        }
        const startHr = startTime.split(":")[0];
        const endHr = parseInt(startHr) + parseInt(duration);
        if(endHr > 9){
            return endHr + ":" + startTime.split(":")[1];
        }else{
            return "0" + endHr + ":" + startTime.split(":")[1];
        }
    }
    //---------------------------------------------------------------------
    const history = useHistory();
    const location = useLocation();
    const id = location.pathname.split("/")[2] && weeknum(new Date());
    //---------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    const [rawData, setRawData] = useState([]);
    const [showLoading, setShowLoading] = useState(true);
    const [weeks, setWeeks] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [department, setDepartment] = useState("");
    const [status, setStatus] = useState("All");
    const [filterWords, setFilterWords] = useState("");
    const [wk, setWk] = useState(() => !weeks.includes(id)?weeknum((new MyDate()).s()):id);
    //---------------------------------------------------------------------
    const filteredData0 = rawData.filter(raw =>
        (status !== "All")?
            (
                (status === "Submitted")?
                    (raw.status === "Submitted")
                    :
                    (status === "Approved")?
                        raw.status === "Approved"
                        :
                        raw.status === "Rejected"
            )
            :
            true
    );
    const filteredData = filteredData0
    .filter(raw => 
        weeknum(raw.date) === wk && 
        raw.hours !== 0 && 
        raw.hours !== "0" && 
        weeknum(raw.date) === wk &&
        (department === "All" || department === "" ? true : department === raw.department) && 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            raw.requester
        )?.toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    )
    //---------------------------------------------------------------------
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const getData = async() => {
            setShowLoading(true);
            const resWeeks = await myAxios("offCalendar/readDayOffsWeek.php");
            if(!isMounted) return;
            setShowLoading(false);
            if(!resWeeks) return;
            const curWeeks = buildWeekNumArray(resWeeks.data.minTime, resWeeks.data.maxTime).reverse();
            setWeeks(curWeeks);
            //-------------------------------------------------
            //setUsersList(resUser.data);
            const formData = new MyFormData();
            formData.append("start", getDatefromWeekNum(wk, 0));
            formData.append("end", getDatefromWeekNum(wk, 6));
            //--------------------------------------------------------
            setShowLoading(true);
            const res = await myAxios("offCalendar/readDayOffs.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //--------------------------------------------------------
            const data = res.data.map(d => 
            JSON.parse(d.data).map(dd => ({
                ...dd, 
                requesterEmail: d.requesterEmail, 
                requester: d.requester, 
                status: d.status === "Re-Submitted"?"Submitted":d.status,
                dayOffHashKey: d.dayOffHashKey,
                endTime: calculateEndTime(dd.startTime, dd.hours),
                department: d.department
            })) 
            ).reduce(arrayReducer,[]);
            setRawData(data);
            const departments = data.map(r => r.department).filter(onlyUnique).sort().reverse();
            if(!curWeeks.includes(wk)){
                history.replace(`/${title}/${weeknum(new Date())}`);
            }else{
                history.replace(`/${title}/${wk}`);
            }
            setDepartments(departments);
        }
        getData();
        return () => {isMounted = false}
    },[history, wk, updateDateTime])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //---------------------------------------------------------------------
    return (
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    Off Calendar
                    <button type = "button" data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</button>
                </span>
                <span className = "mr-4">
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "status" className = "mb-0">Department:</label>
                    <select id = "status" className = "form-control w-auto ml-2" onChange = {e => setDepartment(e.currentTarget.value)}>
                        <option>All</option>
                        {departments.map((dpt, key) => <option key = {key}>{dpt}</option>)}
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "department" className = "mb-0">Status:</label>
                    <select id = "department" className = "form-control w-auto ml-2" onChange = {e => setStatus(e.currentTarget.value)}>
                        <option>All</option>
                        <option>Submitted</option>
                        <option>Approved</option>
                        <option>Rejected</option>
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "week" className = "mb-0">
                        Week:
                    </label>
                    <select
                        id = "week"
                        className = "form-control w-auto ml-2"
                        value = {wk}
                        onChange = {e => {
                            setWk(e.currentTarget.value);
                            history.push(`/${title}/${e.currentTarget.value}`);
                        }}
                    >
                        {weeks.map((wk, key) => <option key = {key}>{wk}</option>)}
                    </select>
                </span>
            </div>
            {showLoading?<div className = "cssContent pb10"><div className = "cssLoading">Loading...</div></div>:
            !filteredData.length?<div className = "cssContent pb10"><div className = "cssLoading">Empty</div></div>:
            <div>
                <div className = "text-center font-weight-bold my-3">
                    <span className = "font-weight-bold mr-4">Status Color Code</span>
                    <span style = {{color:"purple", padding: 10, border:"1px solid black", borderRight:"none"}}>Submitted ({filteredData.filter(v=> v.status === "Submitted").length})</span>
                    <span style = {{color:"green", padding: 10, borderTop:"1px solid black", borderBottom:"1px solid black"}}>Approved ({filteredData.filter(v=> v.status === "Approved").length})</span>
                    <span style = {{color:"gray", padding: 10, border:"1px solid black", borderLeft:"none"}}>Rejected ({filteredData.filter(v=> v.status === "Rejected").length})</span>
                </div>
                <div className = "overflow-visible">
                    <table className = "table">
                        <thead>
                            <tr className = "stickyHeader">
                                <th>Monday ({wk?getDatefromWeekNum(wk, 0):null})</th>                    
                                <th>Tuesday ({wk?getDatefromWeekNum(wk, 1):null})</th>
                                <th>Wednesday ({wk?getDatefromWeekNum(wk, 2):null})</th>
                                <th>Thursday ({wk?getDatefromWeekNum(wk, 3):null})</th>
                                <th>Friday ({wk?getDatefromWeekNum(wk, 4):null})</th>
                                <th>Saturday ({wk?getDatefromWeekNum(wk, 5):null})</th>
                                <th>Sunday ({wk?getDatefromWeekNum(wk, 6):null})</th>
                            </tr>
                        </thead>
                        <tbody> 
                            <tr>
                                {[0, 1, 2, 3, 4, 5, 6].map((num, numi) => <td key = {numi} className = "align-top">
                                    <ul>
                                        {filteredData
                                        .filter(vx => vx.hours !== 0 && vx.hours !== "0" && vx.date === (wk?getDatefromWeekNum(wk, num):null))
                                        .map((vv, vvi) => 
                                        <li
                                            className = "border rounded p-2 mb-4"
                                            key = {vvi}
                                        >
                                        <Link to = {`/DayOffs/${vv.dayOffHashKey}`}>
                                        {vv.requester}
                                        {vv.hours === "8"?null:
                                        <span className = "ml-2">
                                            {vv.startTime} ~ {vv.endTime}
                                        </span>}
                                        </Link>
                                        </li>)}
                                    </ul>
                                </td>)}
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>}
        </div>
    )
}